// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__1iop2","label":"style_label__0qizG","text":"style_text__JjpQX","prevPrice":"style_prevPrice__IRm9V","currentPrice":"style_currentPrice__VOYkw"};